import { Pipe, PipeTransform } from '@angular/core';
import { POSITION_LIST } from '@app/config/position.data';

@Pipe({
  name: 'positionIndex'
})
export class PositionIndexPipe implements PipeTransform {

  public data = POSITION_LIST.map(b => { return b });

  transform(value: any): number {

    return this.data.findIndex(x => +x.id === +value);
  }
}
